import { render, staticRenderFns } from "./IdentityIntegration.vue?vue&type=template&id=7e0d985d&scoped=true&"
import script from "./IdentityIntegration.vue?vue&type=script&lang=ts&"
export * from "./IdentityIntegration.vue?vue&type=script&lang=ts&"
import style0 from "./IdentityIntegration.vue?vue&type=style&index=0&id=7e0d985d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0d985d",
  null
  
)

export default component.exports